<template>
  <div>
    <v-container class="bdo-login-container" fluid>
      <v-row v-if="!display_authentication_token">
        <v-col md="4" offset-md="4">
          <v-alert v-if="display_success_message" class="pa-3" border="top" type="success" outlined dismissible dense>
            {{ success_message }}
          </v-alert>
          <v-alert v-if="display_error_message" class="pa-3" border="top" color="bdoRed" outlined dismissible dense>
            {{ error_message }}
          </v-alert>
          <v-card>
            <v-card-title class="mb-4">
              <h3>Login</h3>
            </v-card-title>
            <v-form v-model="validLogin">
              <v-text-field
                class="pl-4 pr-4"
                id="email"
                v-model="login.email"
                label="E-mail address"
                type="email"
                outlined
                dense
                :rules="emailRules"
              ></v-text-field>
              <v-text-field
                class="pl-4 pr-4"
                id="password"
                v-model="login.password"
                label="Password"
                type="password"
                outlined
                dense
                :rules="required"
              ></v-text-field>
              <div class="flex-row-wrapper">
                <div class="fg-1">
                  <v-btn class="primary-btn ml-4 mb-4" @click="submit" :disabled="!validLogin" :loading="btnLoading">
                    Login »
                  </v-btn>
                </div>
                <div>
                  <span class="flex-href" v-on:click="forgotPasswordModal = true">Forgot password?</span>
                </div>
              </div>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="display_authentication_token">
        <v-col md="4" offset-md="4">
          <v-card>
            <v-card-title class="mb-4">
              <h3>Two-factor authentication</h3>
              <p>Enter the verification code sent to your email address to continue</p>
            </v-card-title>
            <v-form v-model="validToken">
              <v-text-field
                class="pl-4 pr-4"
                id="auth_token"
                v-model="authentication_token"
                label="Enter code"
                outlined
                dense
                :rules="tokenRules"
              ></v-text-field>
              <div class="flex-row-wrapper">
                <div class="fg-1">
                  <v-btn
                    class="primary-btn ml-4 mb-4"
                    @click="submitAuthToken"
                    :disabled="!validToken"
                    :loading="btnLoading"
                  >
                    Verify »
                  </v-btn>
                </div>
              </div>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="forgotPasswordModal" top="220" max-width="460" persistent>
      <v-card class="pb-2">
        <v-card-title>
          <h3>Forgot your password?</h3>
        </v-card-title>
        <v-form v-model="validForgotPassword">
          <v-text-field
            class="pl-6 pr-6 mt-5"
            id="forgot_password_email_address"
            v-model="forgot_password_email_address"
            label="E-mail address"
            type="email"
            outlined
            dense
            :rules="emailRules"
          ></v-text-field>
          <v-card-actions class="pt-6">
            <v-spacer></v-spacer>
            <v-btn
              class="primary-btn"
              @click="submitForgotPassword"
              :disabled="!validForgotPassword"
              :loading="btnLoading"
            >
              Send e-mail
              <v-icon class="ml-2">mdi-email-outline</v-icon>
            </v-btn>
            <v-btn class="secondary-btn white--text elevation-0" @click="forgotPasswordModal = false">
              Cancel
              <v-icon class="ml-2 white--text">mdi-close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import helpers from '@/plugins/helpers'
import config from '@/config'
export default {
  data: () => ({
    login: {
      email: '',
      password: ''
    },
    forgot_password_email_address: '',
    authentication_token: '',
    error_message: '',
    success_message: '',
    display_authentication_token: false,
    display_error_message: false,
    display_success_message: false,
    btnLoading: false,
    forgotPasswordModal: false,
    validLogin: false,
    validToken: false,
    required: [v => !!v || 'This field is required'],
    emailRules: [
      v => !!v || 'This field is required',
      v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
    ],
    tokenRules: [v => !!v || 'This field is required', v => v.length === 6 || 'Token must be 6 characters long.']
  }),
  computed: {},
  methods: {
    async submit() {
      this.btnLoading = true
      let response = await helpers.fetchApi(config.apiUrl + `request-authentication-token`, 'POST', {
        login: this.login,
        country_code: this.$route.params.countrycode,
        _csrf: this.$store.state.general.tempcsrf
      })
      if (response && response.statusCode == 200) {
        if (response.two_factor) {
          this.display_authentication_token = true
        } else {
          this.display_success_message = true
          this.success_message = 'Successfully logged in'
          this.$router.push({ path: `/${this.$route.params.countrycode}/questionnaires` })
        }
      } else {
        this.display_error_message = true
        if (response.message) {
          this.error_message = response.message
        } else {
          this.error_message = 'Something went wrong, try again.'
        }
      }
      this.btnLoading = false
    },

    async submitAuthToken() {
      this.btnLoading = true
      let data = {
        login: {
          email: this.login.email,
          password: this.login.password,
          authentication_token: this.authentication_token
        },
        country_code: this.$route.params.countrycode,
        _csrf: this.$store.state.general.tempcsrf
      }
      let response = await helpers.fetchApi(config.apiUrl + 'login', 'POST', data)
      if (response) {
        if (response.user.is_logged_in) {
          if (response.user.authentication_token_expired) {
            this.display_error_message = true
            this.error_message = 'Token is expired... Try to login again.'
            this.authentication_token = ''
            this.display_authentication_token = false
          } else if (response.user.force_password_reset) {
            this.$router.push({
              path: `/${this.$route.params.countrycode}/password-reset/${response.user.forgot_password_token}`
            })
            this.error_message = 'Password needs to be changed.'
          } else {
            this.$router.push({ path: `/${this.$route.params.countrycode}/questionnaires` })
          }
        } else {
          this.display_error_message = true
          this.error_message = 'Invalid token. Try to login again.'
          this.authentication_token = ''
          this.display_authentication_token = false
        }
        this.btnLoading = false
      } else {
        this.error_message = 'Something went wrong. Try to login again!'
        this.display_authentication_token = false
        this.btnLoading = false
      }
    },

    async submitForgotPassword() {
      this.btnLoading = true
      let response = await helpers.fetchApi(config.apiUrl + 'forgot-password', 'POST', {
        email: this.forgot_password_email_address,
        country_code: this.$route.params.countrycode,
        _csrf: this.$store.state.general.tempcsrf
      })
      if (response) {
        this.forgotPasswordModal = false
        this.btnLoading = false
        if (response.message) {
          this.display_success_message = true
          this.success_message = response.message
        } else {
          this.display_error_message = true
          this.error_message = 'Something went wrong'
        }
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/style/_variables.scss';
.flex-row-wrapper {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
}
.flex-href {
  overflow-y: auto;
  padding: 2em;
  color: #428bca !important;
}
.flex-href:hover {
  cursor: pointer;
  color: lightgray !important;
}
.fg-1 {
  flex-grow: 1;
}
.secondary-btn {
  background-color: #333 !important;
}
</style>
